var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.81 35.61"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "image")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.41,35.61H5.4A5.4,5.4,0,0,1,0,30.21V5.4A5.4,5.4,0,0,1,5.4,0h33a5.4,5.4,0,0,1,5.4,5.4V30.21A5.4,5.4,0,0,1,38.41,35.61ZM5.4,3A2.41,2.41,0,0,0,3,5.4V30.21a2.4,2.4,0,0,0,2.4,2.4h33a2.39,2.39,0,0,0,2.4-2.4V5.4A2.4,2.4,0,0,0,38.41,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.35,29.49.65,27l7.43-5.16a5.31,5.31,0,0,1,6,0L18.74,25a2.29,2.29,0,0,0,3.09-.48l6.56-8.42a5.24,5.24,0,0,1,4.16-2h0a5.26,5.26,0,0,1,4.17,2l6.78,8.68-2.37,1.85L34.35,18a2.25,2.25,0,0,0-1.8-.88h0a2.3,2.3,0,0,0-1.8.88L24.2,26.38a5.3,5.3,0,0,1-7.14,1.12l-4.68-3.18a2.29,2.29,0,0,0-2.59,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.32,19a7.17,7.17,0,1,1,7.17-7.17A7.18,7.18,0,0,1,17.32,19Zm0-11.34a4.17,4.17,0,1,0,4.17,4.17A4.17,4.17,0,0,0,17.32,7.68Z"
  })))));
}

export default SvgImage;